import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { ENV_APP_PROJECT } from '@apps-common/lib/environment'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IAuthActionResponse, IForgotPasswordModel } from '@apps-common/types/auth'

const project = ENV_APP_PROJECT

export const forgotPassword = async (model: IForgotPasswordModel): Promise<IAuthActionResponse> => {
  const url = project === 'my-monitoring' ? '/my-monitoring/account/ForgotPassword' : '/account/ForgotPassword'
  console.log(`using url: ${url}`)
  return axios.post(url, model).then((res) => ({ result: res?.data?.result, message: res?.data?.msg }))
}

type Props = {
  model: IForgotPasswordModel
}

export const useForgotPassword = (
  notify?: boolean,
  onSuccess?: (data: IAuthActionResponse, variables: Props['model']) => void,
  onFailure?: ({ model }: Props) => void
) =>
  useMutation({
    mutationKey: ['forgotPassword'],
    mutationFn: ({ model }: Props) => forgotPassword(model),
    onSuccess: (data, variables) => {
      if (onSuccess) {
        onSuccess(data, variables.model)
      }
      if (notify) {
        toastSuccess(data?.message || 'Email link sent.')
      }
    },
    onError: (error, variables) => {
      if (onFailure) {
        onFailure(variables)
      }
      if (notify) {
        toastError(error?.message || 'Failed to email link.')
      }
    },
    throwOnError: false
  })
